import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
// import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { postFetcherForRegister } from "../../../api/fetchers";
import { useNavigate } from "react-router-dom";
import { endpoints } from "../../../api/endpoints";
import styles from "./SupplierApplicationForm.module.css";
// import globalStyles from "../../styles/globalStyles.module.css";
// import register from "../../assets/images/register.svg";
import { parseStatics } from "../../function/parseStatics";
import RegisterPromotionMan from "../../assets/images/human.png";
import { FaChevronLeft } from "react-icons/fa";
import { useLanguage } from "../../context/LanguageContext";

// const validationSchema = Yup.object({
//   name: Yup.string().required("Ad zorunludur."),
//   surname: Yup.string().required("Soyad zorunludur."),
//   email: Yup.string()
//     .email("Geçersiz e-posta adresi.")
//     .required("E-posta zorunludur."),
//   phone: Yup.string()
//     .matches(/^[0-9]{10}$/, "Geçersiz telefon numarası.")
//     .required("Telefon numarası zorunludur."),
//   address: Yup.string().required("Adres zorunludur."),
//   refCode: Yup.string(),
//   companyName: Yup.string().required("Şirket Adı zorunludur."),
//   identityNo: Yup.string().required("Kimlik Numarası zorunludur."),
//   taxNumber: Yup.string().required("Vergi Numarası zorunludur."),
//   taxOffice: Yup.string().required("Vergi Dairesi zorunludur."),
//   kepAddress: Yup.string().required("Kep Adresi zorunludur."),
//   businessPackageId: Yup.object().shape({
//     id: Yup.string(),
//     name: Yup.string(),
//   }),
//   password: Yup.string()
//     .min(8, "Şifre en az 8 karakter olmalıdır.")
//     .matches(/[A-Z]/, "Şifre en az bir büyük harf içermelidir.")
//     .required("Şifre zorunludur."),
//   confirmPassword: Yup.string()
//     .oneOf([Yup.ref("password")], "Şifreler aynı olmalıdır.")
//     .required("Şifreyi doğrulama zorunludur."),
//   status: Yup.boolean()
//     .oneOf([true], "Gizlilik ve Güvenlik Politikası'nı kabul etmelisiniz.")
//     .required("Gizlilik ve Güvenlik Politikası'nı kabul etmelisiniz."),
//   statusTwo: Yup.boolean()
//     .oneOf([true], "Mesefeli Satış Sözleşmesi'ni kabul etmelisiniz.")
//     .required("Gizlilik ve Güvenlik Politikası'nı kabul etmelisiniz."),
// });

// interface businessPackageId {
//     id: number;
//     name: string;
// }

// interface cities {
//     plate: number;
//     city: string;
// }

const SupplierApplicationForm: React.FC = () => {
  const { t } = useLanguage();
  const [error, setError] = useState("");
  //const [businessPackages, setBusinessPackages] = useState<businessPackageId[]>([]);
  // const [cities, setCities] = useState<cities[]>([]);
  //const [isBusinessPackageDropdownOpen, setIsBusinessPackageDropdownOpen] = useState<boolean>(false);

  const randomString = Math.random().toString(36).substring(2, 8);

  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      name: "",
      surname: "",
      email: "",
      phone: "",
      address: "",
      refCode: "",
      companyName: "",
      identityNo: randomString,
      taxNumber: "",
      taxOffice: randomString,
      kepAddress: randomString,
      businessPackageId: { id: "", name: "" },
      password: "",
      confirmPassword: "",
      status: false,
      statusTwo: false,
      prk: false,
    },
    // validationSchema,
    onSubmit: async (values) => {
      setError("");
      const result: any = await postFetcherForRegister(
        endpoints.auth.register,
        {
          arg: {
            firstName: values.name,
            lastName: values.surname,
            email: values.email,
            phoneNumber: values.phone,
            password: values.password,
            profilePicture: "",
            openAddress: values.address,
            referenceCode: values.refCode,
            companyName: values.companyName,
            identityNo: randomString,
            taxNumber: values.taxNumber,
            taxOffice: randomString,
            city: "",
            district: "",
            kepAddress: randomString,
            businessPackageId: values.businessPackageId.id,
            status: false,
            prk: false,
          },
        }
      );
      if (typeof result === "string") {
        setError(result);
        localStorage.removeItem("formData");
      } else {
        toast.success(t("toastMessage", "e1"), {
          hideProgressBar: true,
        });

        localStorage.removeItem("formData");
        // const updatedFields: Partial<FormikValues> = Object.keys(values).reduce((acc, key) => {
        //     if (values[key as keyof FormikValues] !== initialValues[key as keyof FormikValues]) {
        //         acc[key as keyof FormikValues] = values[key as keyof FormikValues];
        //     }
        //     return acc;
        // }, {} as Partial<FormikValues>);
        // setUser({
        //     ...user!,
        //     ...localStorage.get('formData'),
        // });
        // localStorage.setItem("user", JSON.stringify(values));
        setTimeout(() => {
          navigate("/");
        }, 2000);
      }
    },
  });

  useEffect(() => {
    const savedStatus = localStorage.getItem("checkboxStatus");
    if (savedStatus === "true") {
      formik.setFieldValue("status", true);
      formik.setFieldValue("statusTwo", true);
    }
  }, []);

  useEffect(() => {
    // async function fetchBusinessPackages() {
    //     try {
    //         const data = await getFetcher(endpoints.auth.getBusinessPackages);
    //         setBusinessPackages(data.businessPackages);
    //     } catch (error) {
    //         console.error('Error fetching business packages:', error);
    //     }
    // }
    // async function fetchCitiesData() {
    //     try {
    //         const data = await postFetcher(endpoints.auth.getCitiesByCountry, {
    //             arg: {
    //                 country: 'US'
    //             }
    //         });
    //         setCities(data.cities);
    //     } catch (error) {
    //         console.error('Error fetching cities:', error);
    //     }
    // }
  }, []);

  const handleNavigate = (path: string) => {
    formik.setFieldValue("status", true);
    formik.setFieldValue("statusTwo", true);
    localStorage.setItem("checkboxStatus", "true");
    localStorage.setItem("formData", JSON.stringify(formik.values));
    navigate(path);
  };

  useEffect(() => {
    const savedFormData = localStorage.getItem("formData");
    if (savedFormData) {
      formik.setValues(parseStatics(savedFormData));
    }
    const savedStatus = localStorage.getItem("checkboxStatus");
    if (savedStatus === "true") {
      formik.setFieldValue("status", true);
      formik.setFieldValue("statusTwo", true);
    }
  }, []);

  // const toggleDropdown = (dropdownSetter: React.Dispatch<React.SetStateAction<boolean>>) => {
  //     dropdownSetter(prev => !prev);
  // };

  // const handleDropdownSelect = (field: string, value: { id: number, name: string }) => {
  //     formik.setFieldValue(field, value);
  //     if (field === 'businessPackageId') setIsBusinessPackageDropdownOpen(false);
  // };

  return (
    <div className="flex flex-col md:flex-row min-h-screen md:h-full w-screen bg-primary-color !border-r-8">
      <ToastContainer />
      {/* LEFT SİDE START */}
      {/* <div
        className={`w-full md:w-1/2 flex items-center justify-center bg-white ${styles.leftSide} hidden md:flex`}
      >
        <img
          src={register}
          alt="Register Illustration"
          className="object-cover self-end"
        />
      </div> */}
      {/* LEFT SİDE END */}

      {/* RİGHT SİDE START */}
      <div
        className={`w-full h-full flex flex-col items-center justify-center`}
      >
        <div className="flex w-full h-[500px] text-white justify-center items-center ">
          <div className="px-4">
            {/* <p className="text-3xl font-poppins">
              <p className="font-bold font-poppins">B2B - Kayıt Formu</p>
              Lütfen aşağıdaki formu doldurunuz.
            </p> */}
            <div
              onClick={() => navigate("/")}
              className=" flex items-center gap-x-2 cursor-pointer hover:underline mb-4 text-sm"
            >
              <div>
                <FaChevronLeft size={15} />
              </div>
              <p>{t("supplierAppForm", "navHome")}</p>
            </div>
            <a className="font-bold font-poppins text-3xl">Novamed</a>{" "}
            <a className="font-bold font-poppins text-[#FFC633] text-3xl">
              Shop
            </a>
            <br></br>
            <br></br>
            <br></br>
            <a className="font-poppins text-sm hidden md:block">
              {t("supplierAppForm", "text1")}
              <br></br>
              {t("supplierAppForm", "text2")}
              <br></br>
              <br></br>
              {t("supplierAppForm", "text3")} <br></br>
              {t("supplierAppForm", "text4")}
            </a>
          </div>
          <img
            src={RegisterPromotionMan}
            className="h-[300px] w-[500px] object-cover hidden md:flex"
          ></img>
        </div>

        <div className="w-full  p-8 space-y-8 -mt-20">
          {/* REGİSTRATİON FORM */}
          <h1
            className={`w-full text-4xl font-poppins text-center text-white mb-10 font-semibold `}
          >
            {t("supplierAppForm", "title")}
          </h1>

          <div className=" flex flex-col lg:flex-row w-10/12 mx-auto gap-10 ">
            <div className=" flex-1 font-poppins font-semibold text-lg mt-2 lg:mt-32 space-y-5">
              <p className=" text-yellow-color">{t("supplierAppForm", "left1")}</p>
              <p className=" text-white">{t("supplierAppForm", "left2")}</p>
              <p className=" text-yellow-color">{t("supplierAppForm", "left3")}</p>
            </div>
            <form
              className="space-y-8 md:w-1/2 xl:w-1/3 mx-auto flex-1"
              onSubmit={formik.handleSubmit}
            >
              <div className=" flex w-full gap-x-10 ">
                {/* NAME INPUT */}
                <div className="relative flex-1">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder={t("supplierAppForm", "f1")}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white  focus:outline-none placeholder-gray-200 placeholder:font-bold placeholder:text-[13px] shadow-sm sm:text-sm ${styles["placeholder-bold"]}`}
                    required
                  />
                  {formik.touched.name && formik.errors.name ? (
                    <div className="text-red-200 text-sm">
                      {formik.errors.name}
                    </div>
                  ) : null}
                </div>
                {/* LASTNAME INPUT */}
                <div className="relative flex-1">
                  <input
                    type="text"
                    id="surname"
                    name="surname"
                    placeholder={t("supplierAppForm", "f2")}
                    value={formik.values.surname}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white placeholder-gray-200 placeholder:font-bold placeholder:text-[13px] focus:outline-none shadow-sm sm:text-sm ${styles["placeholder-bold"]}`}
                    required
                  />
                  {formik.touched.surname && formik.errors.surname ? (
                    <div className="text-red-200 text-sm">
                      {formik.errors.surname}
                    </div>
                  ) : null}
                </div>
              </div>

              <div className=" flex w-full gap-x-10">
                {/* E-MAİL INPUT */}
                <div className="relative flex-1">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder={t("supplierAppForm", "f3")}
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white placeholder-gray-200 placeholder:font-bold placeholder:text-[13px] focus:outline-none shadow-sm sm:text-sm ${styles["placeholder-bold"]}`}
                    required
                  />
                  {formik.touched.email && formik.errors.email ? (
                    <div className="text-red-200 text-sm">
                      {formik.errors.email}
                    </div>
                  ) : null}
                </div>

                {/* PHONE NUMBER INPUT */}
                <div className="relative flex-1">
                  <input
                    type="text"
                    id="phone"
                    name="phone"
                    placeholder={t("supplierAppForm", "f4")}
                    maxLength={40}
                    value={formik.values.phone}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white placeholder-gray-200 placeholder:font-bold placeholder:text-[13px] focus:outline-none shadow-sm sm:text-sm ${styles["placeholder-bold"]}`}
                    required
                  />
                  {/* {formik.touched.phone && formik.errors.phone ? (
                  <div className="text-red-200 text-sm">
                    {formik.errors.phone}
                  </div>
                ) : null} */}
                </div>
              </div>

              {/* BUSINESS PACKAGE INPUT
                        <div className="relative inline-block text-left w-full">
                        <div>
                                <button
                                    type="button"
                                    className={`inline-flex border justify-between w-full py-2 pl-2 font-bold mt-1 bg-transparent border-b-2 border-white focus:outline-none shadow-sm sm:text-sm text-white`}
                                    id="company-type-button"
                                    aria-expanded={isBusinessPackageDropdownOpen}
                                    aria-haspopup="true"
                                    onClick={() => toggleDropdown(setIsBusinessPackageDropdownOpen)}
                                >
                                    {formik.values.businessPackageId?.name || 'Şirket Türü'}
                                    <IoIosArrowDown className="ml-2 h-5 w-5 text-gray-400"/>
                                </button>
                            </div>
                            {isBusinessPackageDropdownOpen && (
                                <div
                                    className="absolute right-0 z-10 mt-2 w-full max-h-32 overflow-y-auto origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                                    role="menu" aria-orientation="vertical" aria-labelledby="company-type-button">
                                    <div className="py-1" role="none">
                                        {businessPackages?.map((bpackage) => (
                                            <a href="#"
                                               className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                               role="menuitem"
                                               onClick={() => handleDropdownSelect('businessPackageId', {
                                                   id: bpackage.id,
                                                   name: bpackage.name
                                               })}
                                               key={bpackage.id}>
                                                {bpackage.name}
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            )}
                            {formik.touched.businessPackageId && formik.errors.businessPackageId ? (
                                <div className="text-red-200 text-sm">{formik.errors.businessPackageId?.name}</div>
                            ) : null}
                        </div> */}

              {/* ADRES INPUT */}
              <div className="relative">
                <input
                  type="text"
                  id="address"
                  name="address"
                  placeholder={t("supplierAppForm", "f5")}
                  value={formik.values.address}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white placeholder-gray-200 placeholder:font-bold placeholder:text-[13px] focus:outline-none shadow-sm sm:text-sm ${styles["placeholder-bold"]}`}
                  required
                />
                {formik.touched.address && formik.errors.address ? (
                  <div className="text-red-200 text-sm">
                    {formik.errors.address}
                  </div>
                ) : null}
              </div>

              {/* SELECT CITY
                        <div className="relative">
                            <select
                                id="city"
                                name="city"
                                value={formik.values.city}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white placeholder-gray-200 placeholder:font-bold placeholder:text-[13px] focus:outline-none shadow-sm sm:text-sm ${styles['placeholder-bold']}`}
                            >
                                <option value="" label="Şehir Seçin" className="bg-primary-color"/>
                                {cities.map((city) => (
                                    <option className="bg-primary-color" key={city?.plate} value={JSON.stringify(city?.plate)}>
                                        {city?.city}
                                    </option>
                                ))}
                            </select>
                            {formik.touched.city && formik.errors.city ? (
                                <div className="text-black text-sm">{formik.errors.city}</div>
                            ) : null}
                        </div> */}

              {/* REFERANCE CODE INPUT */}
              <div className=" flex w-full gap-x-10">
                <div className="relative flex-1">
                  <input
                    type="text"
                    id="refCode"
                    name="refCode"
                    placeholder={t("supplierAppForm", "f6")}
                    value={formik.values.refCode}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white placeholder-gray-200 placeholder:font-bold placeholder:text-[13px] focus:outline-none shadow-sm sm:text-sm ${styles["placeholder-bold"]}`}
                  />
                  {formik.touched.refCode && formik.errors.refCode ? (
                    <div className="text-red-200 text-sm">
                      {formik.errors.refCode}
                    </div>
                  ) : null}
                </div>

                {/* COMPANY NAME INPUT */}
                <div className="relative flex-1">
                  <input
                    type="text"
                    id="companyName"
                    name="companyName"
                    placeholder={t("supplierAppForm", "f7")}
                    value={formik.values.companyName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white placeholder-gray-200 placeholder:font-bold placeholder:text-[13px] focus:outline-none shadow-sm sm:text-sm ${styles["placeholder-bold"]}`}
                  />
                  {formik.touched.companyName && formik.errors.companyName ? (
                    <div className="text-red-200 text-sm">
                      {formik.errors.companyName}
                    </div>
                  ) : null}
                </div>
              </div>

              <div className=" flex w-full gap-x-10 ">
                {/* IDENTITY NO INPUT */}
                {/* <div className="relative flex-1">
                <input
                  type="text"
                  id="identityNo"
                  name="identityNo"
                  placeholder="Kimlik Numarası..."
                  value={formik.values.identityNo}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled
                  className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white placeholder-gray-200 placeholder:font-bold placeholder:text-[13px] focus:outline-none shadow-sm sm:text-sm ${styles["placeholder-bold"]}`}
                />
                {formik.touched.identityNo && formik.errors.identityNo ? (
                  <div className="text-red-200 text-sm">
                    {formik.errors.identityNo}
                  </div>
                ) : null}
              </div> */}

                {/* TAX NUMBER INPUT */}
                <div className="relative flex-1">
                  <input
                    type="text"
                    id="taxNumber"
                    name="taxNumber"
                    placeholder={t("supplierAppForm", "f8")}
                    value={formik.values.taxNumber}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white placeholder-gray-200 placeholder:font-bold placeholder:text-[13px] focus:outline-none shadow-sm sm:text-sm ${styles["placeholder-bold"]}`}
                  />
                  {formik.touched.taxNumber && formik.errors.taxNumber ? (
                    <div className="text-red-200 text-sm">
                      {formik.errors.taxNumber}
                    </div>
                  ) : null}
                </div>
              </div>

              <div className=" flex w-full gap-x-10">
                {/* TAX OFFICE INPUT */}
                {/* <div className="relative flex-1">
                <input
                  type="text"
                  id="taxOffice"
                  name="taxOffice"
                  placeholder="Vergi Dairesi..."
                  value={formik.values.taxOffice}
                  disabled
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white placeholder-gray-200 placeholder:font-bold placeholder:text-[13px] focus:outline-none shadow-sm sm:text-sm ${styles["placeholder-bold"]}`}
                />
                {formik.touched.taxOffice && formik.errors.taxOffice ? (
                  <div className="text-red-200 text-sm">
                    {formik.errors.taxOffice}
                  </div>
                ) : null}
              </div> */}

                {/* KEP ADRESS INPUT */}
                {/* <div className="relative flex-1">
                <input
                  type="text"
                  id="kepAddress"
                  name="kepAddress"
                  placeholder="Kep Adresi..."
                  value={formik.values.kepAddress}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled
                  className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white placeholder-gray-200 placeholder:font-bold placeholder:text-[13px] focus:outline-none shadow-sm sm:text-sm ${styles["placeholder-bold"]}`}
                />
                {formik.touched.kepAddress && formik.errors.kepAddress ? (
                  <div className="text-red-200 text-sm">
                    {formik.errors.kepAddress}
                  </div>
                ) : null}
              </div> */}
              </div>

              {/* PASSWORD INPUT */}
              <div className="relative">
                <input
                  type="password"
                  id="password"
                  name="password"
                  placeholder={t("supplierAppForm", "f9")}
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white placeholder-gray-200 placeholder:font-bold placeholder:text-[13px] focus:outline-none shadow-sm sm:text-sm ${styles["placeholder-bold"]}`}
                  required
                />
                {formik.touched.password && formik.errors.password ? (
                  <div className="text-red-200 text-sm">
                    {formik.errors.password}
                  </div>
                ) : null}
              </div>

              {/* CONFIRM PASSWORD INPUT */}
              <div className="relative">
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  placeholder={t("supplierAppForm", "f10")}
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={`block w-full py-2 pl-2 font-bold text-red-100 mt-1 bg-transparent border-b-2 border-white placeholder-gray-200 placeholder:font-bold placeholder:text-[13px] focus:outline-none shadow-sm sm:text-sm ${styles["placeholder-bold"]}`}
                  required
                />
                {formik.touched.confirmPassword &&
                formik.errors.confirmPassword ? (
                  <div className="text-red-200 text-sm">
                    {formik.errors.confirmPassword}
                  </div>
                ) : null}
              </div>

              {/* POLİCY */}
              <div className="relative flex items-start flex-col">
                <div className=" flex">
                  <div className="flex items-center h-5">
                    <input
                      id="status"
                      name="status"
                      type="checkbox"
                      checked={formik.values.status}
                      onChange={(e: any) => {
                        formik.handleChange(e);
                        localStorage.setItem(
                          "checkboxStatus",
                          e.target.checked
                        );
                      }}
                      className="focus:ring-yellow-color h-4 w-4 text-yellow-color border-gray-300 rounded"
                    />
                  </div>
                  <div className="ml-3 text-sm text-white">
                    <label htmlFor="status" className="font-medium text-white">
                      <span
                        onClick={() =>
                          handleNavigate(
                            "/contracts/privacy_and_security_policy"
                          )
                        }
                        className="text-yellow-color hover:underline cursor-pointer"
                      >
                        {t("supplierAppForm", "p1")}
                      </span>{" "}
                      {t("supplierAppForm", "p3")}
                    </label>
                  </div>
                </div>

                <div className=" flex">
                  <div className="flex items-center h-5">
                    <input
                      id="statusTwo"
                      name="statusTwo"
                      type="checkbox"
                      checked={formik.values.statusTwo}
                      onChange={(e: any) => {
                        formik.handleChange(e);
                        localStorage.setItem(
                          "checkboxStatus",
                          e.target.checked
                        );
                      }}
                      className="focus:ring-yellow-color h-4 w-4 text-yellow-color border-gray-300 rounded"
                    />
                  </div>
                  <div className="ml-3 text-sm text-white">
                    <label htmlFor="status" className="font-medium text-white">
                      <span
                        onClick={() =>
                          handleNavigate("/contracts/distance_selling_contract")
                        }
                        className="text-yellow-color hover:underline cursor-pointer"
                      >
                        {t("supplierAppForm", "p2")}
                      </span>{" "}
                      {t("supplierAppForm", "p3")}
                    </label>
                  </div>
                </div>

                <div className=" font-bold">
                  {formik.touched.statusTwo && formik.errors.statusTwo ? (
                    <div className="text-red-200 text-sm">
                      {formik.errors.statusTwo}
                    </div>
                  ) : null}
                </div>
              </div>

              {/* ERROR MESSAGE */}
              {error && (
                <div className="text-red-200 text-sm">
                  {error == "User already exists"
                    ? "Error"
                    : error == "Invalid phone number"
                    ? "Error"
                    : null}
                </div>
              )}

              {/* SEND BUTTON */}
              <div>
                <button
                  type="submit"
                  className={`w-full font-poppins font-bold py-2 px-4 border border-transparent text-sm rounded-md text-primary-color bg-yellow-color hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white ${styles["submit-button"]}`}
                >
                  {t("supplierAppForm", "button")}
                </button>
              </div>
            </form>
          </div>

          {/* <div className="text-center">
            <button
              className="text-white font-bold"
              onClick={() => handleNavigate("/login")}
            >
              Zaten hesabınız var mı? Giriş Yapın
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default SupplierApplicationForm;
